import { render } from "./SalaryShow.vue?vue&type=template&id=4881bd7a&scoped=true"
import script from "./SalaryShow.vue?vue&type=script&lang=js"
export * from "./SalaryShow.vue?vue&type=script&lang=js"

import "./SalaryShow.vue?vue&type=style&index=0&id=4881bd7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4881bd7a"]])

export default __exports__